import { ModalFooter, ModalFooterButton } from '@/components/Modal'

import { useControllerActions } from '../../hooks/useControllerActions'
import { useController } from '../../hooks/useController'
import { useTexts } from '../../useTexts'

import { SubmitIcon } from './components/SubmitIcon'

export function Footer() {
  const { onConfirm } = useControllerActions()
  const texts = useTexts()
  const {
    close,
    status,
    data: { mode },
  } = useController()

  const submitting = status === 'submitting'

  return (
    <ModalFooter
      primaryAction={
        <ModalFooterButton
          Icon={<SubmitIcon mode={mode} />}
          testid="modal-primary-button"
          disabled={submitting}
          loading={submitting}
          onClick={onConfirm}
          variant="contained"
        >
          {mode === 'add' ? texts.addOrders : texts.replaceOrders}
        </ModalFooterButton>
      }
      secondaryAction={
        <ModalFooterButton onClick={close} disabled={submitting} testid="modal-secondary-button">
          {texts.cancel}
        </ModalFooterButton>
      }
    />
  )
}
